angular.module('angus.services').service('widgetService', [
    '$http',
    function ($http) {
        function getWidgetsLegacy() {
            return $http.get(`api/common/widgets-legacy`, {apiV2: true})
                .then(function(response){
                    return response.data;
                })
        }

        return {
            getWidgetsLegacy
        }
    }
]);